'use client';

import { Link } from '@//components/Link';
import { useLegacyTrackManufacturerPackagePageGotoSearch } from '@//data/tracking/useLegacyTrackManufacturerPackagePageGotoSearch';

interface GuaranteePackageLinkProps {
  href: string;
  packageName: string;
  children: React.ReactNode;
}

export const GuaranteePackageLink: React.FC<GuaranteePackageLinkProps> = ({
  href,
  packageName,
  children,
}) => {
  const { trackLegacyManufacturerPackagePageGotoSearch } =
    useLegacyTrackManufacturerPackagePageGotoSearch();

  const handleClick = () => {
    trackLegacyManufacturerPackagePageGotoSearch('bottom', packageName);
  };

  return (
    <Link href={href} onClick={handleClick} prefetch="viewport">
      {children}
    </Link>
  );
};
